export type Platform = 'ios' | 'android' | 'other';

/** Coarse UA-based platform detection — drives the store funnel only. */
export function getPlatform(): Platform {
    const ua = navigator.userAgent;
    if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
    if (/android/i.test(ua)) return 'android';
    return 'other';
}
